import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import classname from "classnames";
import PropTypes from "prop-types";
import { LeavedReaction } from "./LeavedReaction.jsx";
import { useToggleReaction } from "./useToggleReaction.jsx";
import { makeGroupedReactionsByParentSelector } from "../../store/selectors/selector.reactions.jsx";

export const LeavedReactions = ({ parentType, parentId, className, disableToggle }) => {
  const getGroupedReactionsSelector = useMemo(makeGroupedReactionsByParentSelector, []);
  const groupedTypes = useSelector((state) => getGroupedReactionsSelector(state, parentType, parentId));
  const toggleReaction = useToggleReaction(parentType, parentId);

  return groupedTypes?.length ? (
    <div className={classname("current_reactions", className)}>
      {groupedTypes.map((type, index) => (
        <LeavedReaction
          key={index}
          type={type}
          parentType={parentType}
          parentId={parentId}
          onClick={!disableToggle ? toggleReaction : undefined}
          disableTooltip={disableToggle}
          disableToggle={disableToggle}
        />
      ))}
    </div>
  ) : null;
};

LeavedReactions.propTypes = {
  parentType: PropTypes.string.isRequired,
  parentId: PropTypes.number.isRequired,
  disableToggle: PropTypes.bool,
  className: PropTypes.string,
};

LeavedReactions.defaultProps = {
  disableToggle: false,
};
